import './Nav.scss'
import {Link} from "react-router-dom";
import {
    FILTER_KEY_ALL,
    FILTER_KEY_CRYPTO,
    FILTER_KEY_FUNDS,
    FILTER_KEY_STOCKS,
    getFilterPreset
} from "../../ducks/assets-duck.js";
import {useDispatch, useSelector} from "react-redux";
import ChevronRightIcon from "mdi-react/ChevronRightIcon.js";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon.js";
import PlusIcon from "mdi-react/PlusIcon.js";
import {scrollToDashBoard, useNavigation} from "../util/navigation/navigation.js";
import {useSwipeable} from "react-swipeable";
import {activateWidePopup} from "../../ducks/popup-duck.js";
import AssetIcon from "../util/icons/AssetIcon.jsx";
import {APP_ROUTES} from "../../App.jsx";
import {getHasDogAccess, getIsGiljarhus, getIsNavExtended, setIsNavExtended} from "../../ducks/user-duck.js";
import PawIcon from "mdi-react/PawIcon.js";
import LinkList from "./LinkList.jsx";

let timeout = 0

export default () => {

    const dispatch = useDispatch()
    const filterPreset = useSelector(getFilterPreset)
    const isGiljarhus = useSelector(getIsGiljarhus)
    const hasDogAccess = useSelector(getHasDogAccess)
    const isNavExtended = useSelector(getIsNavExtended)
    const {getRoute/*, path*/} = useNavigation()

    // const currentSubPath = path.split('/').slice(2, 3).join('/')

    // const startCloseTimer = () => {
    //     clearTimeout(timeout)
    //     timeout = setTimeout(() => setIsExtended(false), 1.5 * SEC)
    // }

    const instaClose = () => {
        dispatch(setIsNavExtended(false))
        clearTimeout(timeout)
    }

    const leftHandlers = useSwipeable({
        onSwipedLeft: (eventData) => {
            clearTimeout(timeout)
            dispatch(setIsNavExtended(true))
        }
    })

    const rightHandlers = useSwipeable({
        onSwipedRight: (eventData) => {
            clearTimeout(timeout)
            dispatch(setIsNavExtended(false))
        }
    })

    return !isGiljarhus && (
        <>
            <nav
                className={`main-nav ${isNavExtended ? 'is-extended' : 'is-hidden'}`}
                // onClick={startCloseTimer}
                onClick={instaClose}
                {...rightHandlers}
            >
                <div className='nav-menu-wrapper'>
                    { /* eslint-disable-next-line */}
                    <a onClick={() => dispatch(activateWidePopup(<LinkList/>))}>
                        <PlusIcon/>
                    </a>
                    <div className='nav-menu-flyout' onClick={e => e.stopPropagation()}>
                        <LinkList/>
                    </div>
                </div>
                {hasDogAccess &&
                    <Link
                        // to={`/${FILTER_KEY_ALL}/${currentSubPath}`}
                        to={getRoute(APP_ROUTES.dawg)}
                        className={filterPreset === 'dawg' ? 'is-selected' : ''}
                    >
                        <PawIcon/>
                    </Link>
                }
                <div className='separator'/>
                <Link
                    to={getRoute(APP_ROUTES.filter, {filterId: FILTER_KEY_ALL,})}
                    className={filterPreset === FILTER_KEY_ALL ? 'is-selected' : ''}
                    onClick={scrollToDashBoard}
                >
                    <AssetIcon filterPreset={FILTER_KEY_ALL}/>
                </Link>
                <Link
                    to={getRoute(APP_ROUTES.filter, {filterId: FILTER_KEY_CRYPTO,})}
                    className={filterPreset === FILTER_KEY_CRYPTO ? 'is-selected' : ''}
                    onClick={scrollToDashBoard}
                >
                    <AssetIcon filterPreset={FILTER_KEY_CRYPTO}/>
                </Link>
                <Link
                    to={getRoute(APP_ROUTES.filter, {filterId: FILTER_KEY_STOCKS,})}
                    className={filterPreset === FILTER_KEY_STOCKS ? 'is-selected' : ''}
                    onClick={scrollToDashBoard}
                >
                    <AssetIcon filterPreset={FILTER_KEY_STOCKS}/>
                </Link>
                <Link
                    to={getRoute(APP_ROUTES.filter, {filterId: FILTER_KEY_FUNDS,})}
                    className={filterPreset === FILTER_KEY_FUNDS ? 'is-selected' : ''}
                    onClick={scrollToDashBoard}
                >
                    <AssetIcon filterPreset={FILTER_KEY_FUNDS}/>
                </Link>
                { /* eslint-disable-next-line */}
                <a className='insta-close-button' onClick={instaClose}>
                    <ChevronRightIcon filterPreset={FILTER_KEY_FUNDS}/>
                </a>
            </nav>
            <nav
                className={`toggler ${!isNavExtended ? 'is-extended' : 'is-hidden'}`}
                onClick={() => dispatch(setIsNavExtended(true))}
                {...leftHandlers}
            >
                { /* eslint-disable-next-line */}
                <a>
                    <ChevronLeftIcon/>
                    <ChevronLeftIcon/>
                    <ChevronLeftIcon/>
                </a>
            </nav>
        </>
    )
}